











import Vue from 'vue'
import Component from 'vue-class-component'
import SectionTitle from '@/components/SectionTitle.vue'
import { getBrowser } from '@/assets/js/unit'

@Component({
  components: {
    SectionTitle
  }
})
class ServiceProcess extends Vue {
  // isName = true

  // created (): void {
  //   this.isName = getBrowser()
  // }

  get isMobile (): boolean {
    return getBrowser()
  }

  get pcImage (): string {
    const lang = this.$i18n.locale === 'zh'
    const name = lang ? 'process' : 'process.en'
    return require(`@/assets/image/service/${name}.png`)
  }

  get xsImage ():string {
    const lang = this.$i18n.locale === 'zh'
    const name = lang ? 'process-xs' : 'process-xs.en'
    return require(`@/assets/image/service/${name}.png`)
  }
}
export default ServiceProcess
